import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography } from '@mui/material';
import React from 'react';
import DefaultModal from './DefaultModal';

interface Props {
  open: boolean;
  handleClose: () => void;
  message?: string;
}

const ErrorModal = (props: Props): JSX.Element => {
  return (
    <DefaultModal open={props.open} handleClose={props.handleClose}>
      <Box sx={{ px: 6, pb: 6, minWidth: '400px' }}>
        <Box
          sx={{
            textAlign: 'center',
            mb: 3
          }}
        >
          <ErrorOutlineIcon color="error" sx={{ fontSize: 70 }} />
        </Box>
        <Typography variant="h5" textAlign="center" color="grey.900">
          {props.message}
        </Typography>
      </Box>
    </DefaultModal>
  );
};

export default ErrorModal;
